import request from "../utils/request";

export const pubInfo = (requestTimes) =>request({
    method: 'GET',
    url: '/pubInfo',
    params: {requestTimes},
})
